import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e54448c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-product-tip" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/add_product_bg.png",
  alt: "",
  class: "bg-img"
}, null, -1))
const _hoisted_3 = { class: "add-product-tip-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "add-product-info flex" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "add-product-info-text" }
const _hoisted_8 = { class: "product-title line--2" }

import { t } from '@/plugins/i18n'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: ['product', 'add'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props


const loading = ref(false)
const close = () => {
  emits('close')
}
const addProduct = async () => {
  loading.value = true
  await props.add(props.product, true)
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/associated/close.png",
      alt: "",
      class: "close",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('请先选择三方商品后，再添加此商品来绑定吧！')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: __props.product.productMainImg,
          alt: "",
          class: "product-img"
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(__props.product.productTitle), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "add",
            onClick: addProduct,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('一键添加')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})